require('../multiMap');
require('../position/index-nocss.js');
require('./dropdown');

var MODULE_NAME = 'ui.bootstrap.module.dropdown';

angular.module(MODULE_NAME, ['ui.bootstrap.dropdown']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/dropdown/index-nocss.js
// module id = 461
// module chunks = 1